module.exports = __webpack_public_path__ + "static/img/image_support_article_details_p3.99aa482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_p3.png
// module id = aOl8
// module chunks = 10